import produce from 'immer';
import moment from 'moment';
import {
  GET_ARTICULOS_REPOSICIONES_STOCK_SUCCESS,
  GET_ARTICULOS_REPOSICIONES_SUCCESS,
  GET_PROVEEDORES_REPOSICIONES_SUCCESS,
  GET_VALORES_PROPIEDADES_ARTICULOS_SUCCESS, REPOSICIONES_SET_RANGO_FECHAS,
  REPOSICIONES_SET_SEARCH_TEXT,
  RESETEAR_SELECCION,
  SET_DEFAULT_FILTERS,
  SET_FILTER,
  SET_PAGINATION_REPOSICION,
  SET_SELECTED_ARTICULOS_REPOSICION,
  SET_UNIDADES_ARTICULO_REPOSICION,
} from '../actions/constants/newCo.reposiciones.constants';
import { MultipleSelection } from '../../modules/newCo/constants/selectionTypes.constants';

const initialState = {
  articulosReposicionesData: [],
  articulosReposicionesDataModificados: [],
  selection: {
    type: MultipleSelection,
    rowSelection: [],
  },
  filters: {
    searchText: '',
    rangoFechas: { date_ini: moment().add(-1, 'days'), date_fin: moment() },
    pagination: { page: 1, pageSize: 8 },
    tipoArticulo: 3,
    tienda: 0,
    proveedor: null,
    propiedades: {},
  },
  valoresTipo: [],
  proveedores: [],
};
/* eslint no-param-reassign: ["error", { "props": true, "ignorePropertyModificationsFor": ["draft"] }] */
export default produce((draft = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_SELECTED_ARTICULOS_REPOSICION: {
      const { type, record, selected } = payload;
      const oldselection = draft.selection.rowSelection;
      const previusFound = oldselection.find(e => e.id === record.id);
      if (previusFound && !selected) draft.selection.rowSelection = oldselection.filter(e => e.id !== previusFound.id);
      if (!previusFound && selected) oldselection.push(record);
      draft.selection.type = type;
      return draft;
    }
    case GET_ARTICULOS_REPOSICIONES_SUCCESS: {
      const { datos } = payload;
      draft.articulosReposicionesData = payload;
      return draft;
    }
    case SET_PAGINATION_REPOSICION: {
      const { current, pageSize } = payload;
      draft.filters.pagination = { page: current, pageSize };
      return draft;
    }
    case SET_UNIDADES_ARTICULO_REPOSICION: {
      const { rowKey, unidades } = payload;
      const articulo = draft.articulosReposicionesData.datos.find(e => e.id === rowKey);
      const articuloYaModificado = draft.articulosReposicionesDataModificados.find(e => e.id === rowKey);
      if (articuloYaModificado) {
        articuloYaModificado.unidadesPropuestas = unidades;
      } else {
        draft.articulosReposicionesDataModificados.push({ ...articulo, unidadesPropuestas: parseInt(unidades, 10) });
      }
      return draft;
    }
    case GET_ARTICULOS_REPOSICIONES_STOCK_SUCCESS: {
      payload.forEach(({ cdgedi, stock }) => {
        const articulo = draft.articulosReposicionesData.datos.find(e => e.codigoEdi === cdgedi);
        const articuloYaModificado = draft.articulosReposicionesDataModificados.find(e => e.codigoEdi === cdgedi);
        if (articuloYaModificado) {
          articuloYaModificado.stock = stock;
        } else {
          draft.articulosReposicionesDataModificados.push({ ...articulo, stock });
        }
      });
      return draft;
    }
    case GET_PROVEEDORES_REPOSICIONES_SUCCESS: {
      draft.proveedores = payload.datos;
      return draft;
    }
    case SET_DEFAULT_FILTERS: {
      const { tienda, tipoArticulo, subtiposArticulo } = payload;
      draft.filters.tienda = tienda;
      draft.filters.tipoArticulo = tipoArticulo;
      draft.filters.proveedor = draft.proveedores[0].id;
      subtiposArticulo.filter(e => e.tipo.id === tipoArticulo).forEach((e) => {
        draft.filters.propiedades[e.nombre] = -1;
      });
      return draft;
    }
    case SET_FILTER: {
      const { tipo, value, esPropiedades } = payload;
      if (!esPropiedades) {
        draft.filters[tipo] = value;
      } else {
        draft.filters.propiedades[tipo] = value;
      }
      return draft;
    }
    case REPOSICIONES_SET_SEARCH_TEXT: {
      draft.filters.searchText = payload;
      return draft;
    }
    case REPOSICIONES_SET_RANGO_FECHAS: {
      if (payload.date_fin) draft.filters.rangoFechas.date_fin = payload.date_fin;
      if (payload.date_ini) draft.filters.rangoFechas.date_ini = payload.date_ini;
      return draft;
    }
    case RESETEAR_SELECCION: {
      draft.selection = initialState.selection;
      draft.articulosReposicionesDataModificados = initialState.articulosReposicionesDataModificados;
      return draft;
    }
    case GET_VALORES_PROPIEDADES_ARTICULOS_SUCCESS: {
      const { datos, tipoArticulo, subtiposArticulo } = payload;
      draft.valoresTipo = datos;
      subtiposArticulo.filter(e => e.tipo.id === tipoArticulo).forEach((e) => {
        draft.filters.propiedades[e.nombre] = -1;
      });
      return draft;
    }

    default: {
      return draft;
    }
  }
});
